<script setup lang="ts">

import { faEllipsisVertical, faPenToSquare } from '@fortawesome/pro-regular-svg-icons'

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

import { useDisciplineProgressReportActions } from '../model/discipline-progress-report-actions.hook'

defineOptions({
  name: 'DisciplineProgressReportActions',
})

defineProps<{
  reportId: number
}>()

const emit = defineEmits<{
  'click:edit': []
}>()

const {
  isOpen,
  containerRef,
  floatingRef,
  floatingStyles,
  toggle,
  edit,
} = useDisciplineProgressReportActions({
  onEdit: () => emit('click:edit'),
})
</script>

<template>
  <div
    ref="containerRef"
    class="discipline-progress-report-actions"
  >
    <BtnIcon
      :icon="faEllipsisVertical"
      view="table"
      :title="`Actions for progress report ${reportId}`"
      @click="toggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="discipline-progress-report-actions__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          text="Edit"
          color="blue"
          :prepend-icon="faPenToSquare"
          @click="edit"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineProgressReportActions.scss" />
